export const SEARCH_INPUT_FIELD_WIDTH = 450
